import {
  animate,
  state,
  style,
  transition,
  trigger
} from "@angular/animations";
import {
  Component,
  ElementRef,
  HostListener,
  Input,
  OnInit
} from "@angular/core";
import { Router } from "@angular/router";
import { Platform } from "@ionic/angular";
import { Animations } from "src/app/_helpers/animations";
import { User } from "src/app/_models/user.model";
import { AuthenticationService, UserService } from "src/app/_services";
import { NoInternetService } from "src/app/_services/no-internet.service";
import { ThisPlatform } from "src/app/_services/platform.service";
import { PushNotificationService } from "src/app/_services/push-notification.service";
@Component({
  selector: "app-user-settings",
  templateUrl: "./user-settings.component.html",
  styleUrls: ["./user-settings.component.scss"],
  animations: [
    trigger("toggleHeight", [
      state(
        "inactive",
        style({
          height: "0",
        })
      ),
      state(
        "active",
        style({
          height: "*",
        })
      ),
      transition("inactive => active", animate("150ms ease-in")),
      transition("active => inactive", animate("150ms ease-out")),
    ]),
    Animations.animeRotate,
  ],
})
export class UserSettingsComponent implements OnInit {
  constructor(
    public p: ThisPlatform,
    private authService: AuthenticationService,
    private userServ: UserService,
    private router: Router,
    private elementRef: ElementRef,
    private internetServ: NoInternetService,
    private platform: Platform,
    private pushNotificationServ: PushNotificationService,
  ) {}

  userSubmenuActive: boolean = false;
  userStorage: User = new User();
  mobileView: boolean;

  @Input()
  mobileViewBreakPoint: number = 992;

  ngOnInit() {
    this.authService.currentUser.subscribe(async (user) => {
      this.userStorage = user;
    });
    this.mobileView = this.calcMobileView();
  }

  @HostListener("document:click", ["$event"])
  closeList(event) {
    if (!this.elementRef.nativeElement.contains(event.target)) {
      this.userSubmenuActive = false;
    }
  }

  @HostListener("window:resize", ["$event"])
  onResize() {
    this.mobileView = this.calcMobileView();
  }

  calcMobileView(): boolean {
    return this.mobileViewBreakPoint > window.innerWidth;
  }

  onToggleMenu() {
    this.userSubmenuActive = !this.userSubmenuActive;
  }

  onRedirectToSettings() {
    this.router.navigate(["app/settings"]);
    this.userSubmenuActive = false;
  }

  onLogout() {
    this.internetServ.isOnline = window.navigator.onLine;
    if(this.internetServ.isOnline) {
      this.userServ.permission.next(null);
      this.userSubmenuActive = false;
      this.authService.logout();
      this.unsubscribePush();
      this.router.navigate(["/auth"]);
    }
  }

  private unsubscribePush() {
    if (this.platform.is('cordova')) {
      this.pushNotificationServ.cancelSubscription();
    }
  }
}
